// Keep tokens aligned with CSS vars in colors.css
export const TYPE_COLOR_TOKENS = new Set([
  'string',
  'number',
  'boolean',
  'object',
  'array',
  'any',
]);

/** Normalize arbitrary input (incl. "string→number" / "string->number") to a known coarse token. */
export function normalizeTypeToken(value?: string): string {
  let key = String(value ?? 'any').trim().toLowerCase();
  // Prefer the RHS of a composite (target side color)
  if (key.includes('→')) key = key.split('→').pop()!.trim();
  else if (key.includes('->')) key = key.split('->').pop()!.trim();
  return TYPE_COLOR_TOKENS.has(key) ? key : 'any';
}

export function colorVarForType(value?: string): string {
  return `var(--type-${normalizeTypeToken(value)})`;
}
